import { usePublicConfigContext } from '@/core/contexts/PublicConfigContext';

/**
 * Hook to access public configuration from the context.
 * This is a convenience wrapper around usePublicConfigContext.
 */
export function usePublicConfig() {
  return usePublicConfigContext();
}

